// src/Reasoning.js

import React, { useState } from 'react';
import './Reasoning.css';

const questionsData = [
    {
      question: "If A is taller than B, and B is taller than C, who is the tallest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is taller than B.", "B is taller than C.", "Therefore, A is the tallest."]
    },
    {
      question: "If all roses are flowers and some flowers fade quickly, which statement is true?",
      options: ["All roses fade quickly", "Some roses fade quickly", "No roses fade quickly", "Some flowers do not fade quickly"],
      answer: "Some flowers do not fade quickly",
      solution: ["All roses are flowers.", "Some flowers fade quickly.", "Not all flowers fade quickly.", "Therefore, some flowers do not fade quickly."]
    },
    {
      question: "If John is older than Peter and Peter is older than Mary, who is the youngest?",
      options: ["John", "Peter", "Mary", "Cannot be determined"],
      answer: "Mary",
      solution: ["John is older than Peter.", "Peter is older than Mary.", "Therefore, Mary is the youngest."]
    },
    {
      question: "If all apples are fruits and some fruits are sweet, which statement is true?",
      options: ["All apples are sweet", "Some apples are sweet", "No apples are sweet", "Some fruits are not sweet"],
      answer: "Some fruits are not sweet",
      solution: ["All apples are fruits.", "Some fruits are sweet.", "Not all fruits are sweet.", "Therefore, some fruits are not sweet."]
    },
    {
      question: "If all cars are vehicles and some vehicles are fast, which statement is true?",
      options: ["All cars are fast", "Some cars are fast", "No cars are fast", "Some vehicles are not fast"],
      answer: "Some vehicles are not fast",
      solution: ["All cars are vehicles.", "Some vehicles are fast.", "Not all vehicles are fast.", "Therefore, some vehicles are not fast."]
    },
    {
      question: "If A is older than B, and B is older than C, who is the oldest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is older than B.", "B is older than C.", "Therefore, A is the oldest."]
    },
    {
      question: "If all cats are animals and some animals are pets, which statement is true?",
      options: ["All cats are pets", "Some cats are pets", "No cats are pets", "Some animals are not pets"],
      answer: "Some animals are not pets",
      solution: ["All cats are animals.", "Some animals are pets.", "Not all animals are pets.", "Therefore, some animals are not pets."]
    },
    {
      question: "If A is shorter than B, and B is shorter than C, who is the shortest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is shorter than B.", "B is shorter than C.", "Therefore, A is the shortest."]
    },
    {
      question: "If all birds can fly and some birds are penguins, which statement is true?",
      options: ["All birds are penguins", "Some birds are penguins", "No birds are penguins", "Some birds cannot fly"],
      answer: "Some birds cannot fly",
      solution: ["All birds can fly.", "Some birds are penguins.", "Penguins cannot fly.", "Therefore, some birds cannot fly."]
    },
    {
      question: "If John is younger than Peter and Peter is younger than Mary, who is the oldest?",
      options: ["John", "Peter", "Mary", "Cannot be determined"],
      answer: "Mary",
      solution: ["John is younger than Peter.", "Peter is younger than Mary.", "Therefore, Mary is the oldest."]
    },
    {
      question: "If all squares are rectangles and some rectangles are not squares, which statement is true?",
      options: ["All rectangles are squares", "Some squares are rectangles", "No rectangles are squares", "Some rectangles are not squares"],
      answer: "Some rectangles are not squares",
      solution: ["All squares are rectangles.", "Some rectangles are not squares.", "Therefore, some rectangles are not squares."]
    },
    {
      question: "If A is stronger than B, and B is stronger than C, who is the strongest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is stronger than B.", "B is stronger than C.", "Therefore, A is the strongest."]
    },
    {
      question: "If all dogs are animals and some animals are not mammals, which statement is true?",
      options: ["All dogs are mammals", "Some dogs are mammals", "No dogs are mammals", "Some animals are not mammals"],
      answer: "Some animals are not mammals",
      solution: ["All dogs are animals.", "Some animals are not mammals.", "Therefore, some animals are not mammals."]
    },
    {
      question: "If A is heavier than B, and B is heavier than C, who is the heaviest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is heavier than B.", "B is heavier than C.", "Therefore, A is the heaviest."]
    },
    {
      question: "If all flowers have petals and some petals are red, which statement is true?",
      options: ["All flowers have red petals", "Some flowers have red petals", "No flowers have red petals", "Some petals are not red"],
      answer: "Some petals are not red",
      solution: ["All flowers have petals.", "Some petals are red.", "Not all petals are red.", "Therefore, some petals are not red."]
    },
    {
      question: "If all students are learners and some learners are not diligent, which statement is true?",
      options: ["All students are diligent", "Some students are diligent", "No students are diligent", "Some learners are not diligent"],
      answer: "Some learners are not diligent",
      solution: ["All students are learners.", "Some learners are not diligent.", "Therefore, some learners are not diligent."]
    },
    {
      question: "If A is faster than B, and B is faster than C, who is the fastest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is faster than B.", "B is faster than C.", "Therefore, A is the fastest."]
    },
    {
      question: "If all cars have wheels and some wheels are black, which statement is true?",
      options: ["All cars have black wheels", "Some cars have black wheels", "No cars have black wheels", "Some wheels are not black"],
      answer: "Some wheels are not black",
      solution: ["All cars have wheels.", "Some wheels are black.", "Not all wheels are black.", "Therefore, some wheels are not black."]
    },
    {
      question: "If all chairs have legs and some legs are metal, which statement is true?",
      options: ["All chairs have metal legs", "Some chairs have metal legs", "No chairs have metal legs", "Some legs are not metal"],
      answer: "Some legs are not metal",
      solution: ["All chairs have legs.", "Some legs are metal.", "Not all legs are metal.", "Therefore, some legs are not metal."]
    },
    {
      question: "If A is richer than B, and B is richer than C, who is the richest?",
      options: ["A", "B", "C", "Cannot be determined"],
      answer: "A",
      solution: ["A is richer than B.", "B is richer than C.", "Therefore, A is the richest."]
    },
    {
      question: "If all buildings have roofs and some roofs are flat, which statement is true?",
      options: ["All buildings have flat roofs", "Some buildings have flat roofs", "No buildings have flat roofs", "Some roofs are not flat"],
      answer: "Some roofs are not flat",
      solution: ["All buildings have roofs.", "Some roofs are flat.", "Not all roofs are flat.", "Therefore, some roofs are not flat."]
    },

            // More questions here...
        {
          question: "If 3 is added to twice a number, the result is 11. What is the number?",
          options: ["2", "3", "4", "5"],
          answer: "4",
          solution: ["Let the number be x.", "2x + 3 = 11", "2x = 11 - 3", "2x = 8", "x = 4"]
        },
        {
          question: "If 5 years ago, the age of A was half the age of B, what will be their age difference after 10 years?",
          options: ["5 years", "10 years", "15 years", "20 years"],
          answer: "10 years",
          solution: ["Let the present age of A be x years and that of B be y years.", "According to the given condition, x - 5 = 1/2 (y - 5)", "Solving this, we get y = 2x - 5.", "After 10 years, their age difference remains the same."]
        },
        {
          question: "If the sum of the ages of A and B is 50 and the sum of the ages of B and C is 60, what is the age of C if A is 20 years old?",
          options: ["30", "40", "50", "60"],
          answer: "40",
          solution: ["Let the age of B be y and the age of C be z.", "A + B = 50, B + C = 60", "If A = 20, then 20 + B = 50", "B = 30", "If B = 30, then 30 + C = 60", "C = 30"]
        },
        {
          question: "If 1/4 of a number is subtracted from the original number, the result is 12. What is the number?",
          options: ["10", "12", "15", "16"],
          answer: "16",
          solution: ["Let the number be x.", "x - 1/4x = 12", "3/4x = 12", "x = 12 * 4/3", "x = 16"]
        },
        {
          question: "If the product of two numbers is 45 and their sum is 14, what are the numbers?",
          options: ["5 and 9", "3 and 15", "1 and 45", "6 and 8"],
          answer: "5 and 9",
          solution: ["Let the numbers be x and y.", "xy = 45", "x + y = 14", "On solving, we get x = 5 and y = 9."]
        },
        {
          question: "If the average of three numbers is 20 and two of the numbers are 15 and 25, what is the third number?",
          options: ["15", "20", "25", "30"],
          answer: "20",
          solution: ["Let the three numbers be x, 15, and 25.", "Average = (x + 15 + 25) / 3 = 20", "x + 40 = 60", "x = 20"]
        },
        {
          question: "If two angles of a triangle are 30 degrees and 60 degrees, what is the third angle?",
          options: ["30 degrees", "60 degrees", "90 degrees", "120 degrees"],
          answer: "90 degrees",
          solution: ["Sum of angles in a triangle = 180 degrees", "Given angles = 30 and 60", "Third angle = 180 - (30 + 60) = 90"]
        },
        {
          question: "If the perimeter of a square is 20, what is the area?",
          options: ["5", "10", "25", "100"],
          answer: "25",
          solution: ["Perimeter of a square = 4 * side", "Side = 20 / 4 = 5", "Area = side^2 = 5^2 = 25"]
        },
        {
          question: "If a train travels at a speed of 60 km/hr for 2 hours, how far will it travel?",
          options: ["30 km", "60 km", "90 km", "120 km"],
          answer: "120 km",
          solution: ["Distance = Speed * Time", "Distance = 60 * 2 = 120 km"]
        },
        {
          question: "If the radius of a circle is 7 cm, what is its diameter?",
          options: ["7 cm", "14 cm", "21 cm", "28 cm"],
          answer: "14 cm",
          solution: ["Diameter = 2 * Radius", "Diameter = 2 * 7 = 14 cm"]
        },
        {
          question: "If the sum of the interior angles of a polygon is 540 degrees, how many sides does it have?",
          options: ["3", "4", "5", "6"],
          answer: "5",
          solution: ["Sum of interior angles of a polygon = (n-2) * 180", "540 = (n-2) * 180", "n-2 = 3", "n = 5"]
        },
        {
          question: "If the cost price of an item is $100 and it is sold at a profit of 20%, what is the selling price?",
          options: ["$100", "$110", "$120", "$130"],
          answer: "$120",
          solution: ["Selling Price = Cost Price + Profit", "Profit = 20% of $100 = $20", "Selling Price = $100 + $20 = $120"]
        },
        {
          question: "If 5 pencils cost $2, how much will 15 pencils cost?",
          options: ["$4", "$6", "$8", "$10"],
          answer: "$6",
          solution: ["Cost of 5 pencils = $2", "Cost of 15 pencils = $2 * 3 = $6"]
        },
        {
          question: "If the simple interest on $500 for 2 years is $50, what is the rate of interest per annum?",
          options: ["2%", "4%", "5%", "6%"],
          answer: "5%",
          solution: ["Simple Interest = Principal * Rate * Time / 100", "50 = 500 * Rate * 2 / 100", "Rate = 5%"]
        },
        {
          question: "If a rectangle has a length of 10 cm and a width of 5 cm, what is its perimeter?",
          options: ["15 cm", "20 cm", "25 cm", "30 cm"],
          answer: "30 cm",
          solution: ["Perimeter of a rectangle = 2 * (Length + Width)", "Perimeter = 2 * (10 + 5) = 30 cm"]
        },

          {
              question: "If a car travels at 60 km/h, how long will it take to travel 180 km?",
              options: ["2 hours", "3 hours", "4 hours", "Cannot be determined"],
              answer: "3 hours",
              solution: ["Speed = 60 km/h.", "Distance = 180 km.", "Time = Distance / Speed.", "Time = 180 / 60 = 3 hours."]
            },
            {
              question: "If a light bulb consumes 60 watts of power, how much energy does it consume in 2 hours?",
              options: ["60 watt-hours", "120 watt-hours", "30 watt-hours", "Cannot be determined"],
              answer: "120 watt-hours",
              solution: ["Power = 60 watts.", "Time = 2 hours.", "Energy = Power x Time.", "Energy = 60 x 2 = 120 watt-hours."]
            },
            {
              question: "If the train covers a distance of 240 km in 4 hours, what is its speed?",
              options: ["40 km/h", "50 km/h", "60 km/h", "Cannot be determined"],
              answer: "60 km/h",
              solution: ["Distance = 240 km.", "Time = 4 hours.", "Speed = Distance / Time.", "Speed = 240 / 4 = 60 km/h."]
            },
            {
              question: "If a runner completes a 5 km race in 25 minutes, what is their average speed?",
              options: ["5 km/h", "10 km/h", "12 km/h", "Cannot be determined"],
              answer: "12 km/h",
              solution: ["Distance = 5 km.", "Time = 25 minutes = 25/60 hours.", "Speed = Distance / Time.", "Speed = 5 / (25/60) = 12 km/h."]
            },
            {
              question: "If a machine uses 500 watts of power and operates for 3 hours, how much energy does it consume?",
              options: ["1500 watt-hours", "1200 watt-hours", "1000 watt-hours", "Cannot be determined"],
              answer: "1500 watt-hours",
              solution: ["Power = 500 watts.", "Time = 3 hours.", "Energy = Power x Time.", "Energy = 500 x 3 = 1500 watt-hours."]
            },
            {
              question: "If an object moves with a constant speed of 20 m/s for 10 seconds, what distance does it cover?",
              options: ["200 meters", "150 meters", "100 meters", "Cannot be determined"],
              answer: "200 meters",
              solution: ["Speed = 20 m/s.", "Time = 10 seconds.", "Distance = Speed x Time.", "Distance = 20 x 10 = 200 meters."]
            },
            {
              question: "If a cyclist travels at a speed of 15 km/h for 2 hours, how far do they travel?",
              options: ["30 km", "25 km", "20 km", "Cannot be determined"],
              answer: "30 km",
              solution: ["Speed = 15 km/h.", "Time = 2 hours.", "Distance = Speed x Time.", "Distance = 15 x 2 = 30 km."]
            },
            {
              question: "If a person consumes 2000 calories per day, how much energy do they consume in a week?",
              options: ["14000 calories", "12000 calories", "10000 calories", "Cannot be determined"],
              answer: "14000 calories",
              solution: ["Calories per day = 2000.", "Days in a week = 7.", "Total calories = 2000 x 7 = 14000 calories."]
            },
            {
              question: "If a battery has a capacity of 1000 mAh and is discharged at 500 mA, how long will it last?",
              options: ["2 hours", "3 hours", "4 hours", "Cannot be determined"],
              answer: "2 hours",
              solution: ["Capacity = 1000 mAh.", "Current = 500 mA.", "Time = Capacity / Current.", "Time = 1000 / 500 = 2 hours."]
            },
            {
              question: "If a car accelerates from 0 to 60 km/h in 6 seconds, what is its acceleration?",
              options: ["10 km/h^2", "15 km/h^2", "20 km/h^2", "Cannot be determined"],
              answer: "10 km/h^2",
              solution: ["Initial speed = 0 km/h.", "Final speed = 60 km/h.", "Time = 6 seconds.", "Acceleration = (Final speed - Initial speed) / Time.", "Acceleration = (60 - 0) / 6 = 10 km/h^2."]
            },
            {
              question: "If a plant uses 500 ml of water every day, how much water does it use in 10 days?",
              options: ["5 liters", "4 liters", "6 liters", "Cannot be determined"],
              answer: "5 liters",
              solution: ["Water per day = 500 ml.", "Days = 10.", "Total water = 500 x 10 = 5000 ml = 5 liters."]
            },
            {
              question: "If an airplane flies at a speed of 800 km/h, how far does it travel in 3 hours?",
              options: ["2400 km", "2000 km", "3000 km", "Cannot be determined"],
              answer: "2400 km",
              solution: ["Speed = 800 km/h.", "Time = 3 hours.", "Distance = Speed x Time.", "Distance = 800 x 3 = 2400 km."]
            },
            {
              question: "If a light bulb uses 100 watts of power and is on for 5 hours, how much energy does it use?",
              options: ["500 watt-hours", "400 watt-hours", "600 watt-hours", "Cannot be determined"],
              answer: "500 watt-hours",
              solution: ["Power = 100 watts.", "Time = 5 hours.", "Energy = Power x Time.", "Energy = 100 x 5 = 500 watt-hours."]
            },
            {
              question: "If a computer consumes 150 watts of power, how much energy does it use in 8 hours?",
              options: ["1200 watt-hours", "1000 watt-hours", "1400 watt-hours", "Cannot be determined"],
              answer: "1200 watt-hours",
              solution: ["Power = 150 watts.", "Time = 8 hours.", "Energy = Power x Time.", "Energy = 150 x 8 = 1200 watt-hours."]
            },
            {
              question: "If a swimmer swims 50 meters in 25 seconds, what is their speed?",
              options: ["2 m/s", "3 m/s", "4 m/s", "Cannot be determined"],
              answer: "2 m/s",
              solution: ["Distance = 50 meters.", "Time = 25 seconds.", "Speed = Distance / Time.", "Speed = 50 / 25 = 2 m/s."]
            },
            {
              question: "If a wind turbine generates 500 kWh of energy in 10 hours, what is its power output?",
              options: ["50 kW", "40 kW", "60 kW", "Cannot be determined"],
              answer: "50 kW",
              solution: ["Energy = 500 kWh.", "Time = 10 hours.", "Power = Energy / Time.", "Power = 500 / 10 = 50 kW."]
            },
            {
              question: "If a battery has a capacity of 2000 mAh and a device uses 500 mA, how long will the battery last?",
              options: ["4 hours", "3 hours", "5 hours", "Cannot be determined"],
              answer: "4 hours",
              solution: ["Capacity = 2000 mAh.", "Current = 500 mA.", "Time = Capacity / Current.", "Time = 2000 / 500 = 4 hours."]
            },
         
            
                {
                  question: "If A is B's mother and C is A's father, how is C related to B?",
                  options: ["Grandfather", "Father", "Uncle", "Brother"],
                  answer: "Grandfather",
                  solution: ["A is B's mother.", "C is A's father.", "Therefore, C is B's grandfather."]
                },
                {
                  question: "If D is E's brother and F is D's father, who is F to E?",
                  options: ["Uncle", "Father", "Brother", "Cousin"],
                  answer: "Father",
                  solution: ["D is E's brother.", "F is D's father.", "Therefore, F is E's father."]
                },
                {
                  question: "If G is H's sister and I is G's mother, how is I related to H?",
                  options: ["Aunt", "Mother", "Sister", "Grandmother"],
                  answer: "Mother",
                  solution: ["G is H's sister.", "I is G's mother.", "Therefore, I is H's mother."]
                },
                {
                  question: "If J is K's son and L is J's wife, who is L to K?",
                  options: ["Daughter-in-law", "Wife", "Mother", "Sister"],
                  answer: "Daughter-in-law",
                  solution: ["J is K's son.", "L is J's wife.", "Therefore, L is K's daughter-in-law."]
                },
                {
                  question: "If M is N's father and O is N's daughter, who is O to M?",
                  options: ["Granddaughter", "Daughter", "Sister", "Mother"],
                  answer: "Granddaughter",
                  solution: ["M is N's father.", "O is N's daughter.", "Therefore, O is M's granddaughter."]
                },
                {
                  question: "If P is Q's brother and R is P's son, who is R to Q?",
                  options: ["Nephew", "Brother", "Son", "Uncle"],
                  answer: "Nephew",
                  solution: ["P is Q's brother.", "R is P's son.", "Therefore, R is Q's nephew."]
                },
                {
                  question: "If S is T's mother and U is T's grandmother, who is U to S?",
                  options: ["Mother", "Daughter", "Mother-in-law", "Sister"],
                  answer: "Mother",
                  solution: ["S is T's mother.", "U is T's grandmother.", "Therefore, U is S's mother."]
                },
                {
                  question: "If V is W's father and X is W's son, who is V to X?",
                  options: ["Grandfather", "Father", "Uncle", "Brother"],
                  answer: "Grandfather",
                  solution: ["V is W's father.", "X is W's son.", "Therefore, V is X's grandfather."]
                },
                {
                  question: "If Y is Z's sister and A is Y's daughter, who is A to Z?",
                  options: ["Niece", "Sister", "Mother", "Cousin"],
                  answer: "Niece",
                  solution: ["Y is Z's sister.", "A is Y's daughter.", "Therefore, A is Z's niece."]
                },
                {
                  question: "If B is C's mother and D is C's sister, who is D to B?",
                  options: ["Daughter", "Sister", "Mother", "Granddaughter"],
                  answer: "Daughter",
                  solution: ["B is C's mother.", "D is C's sister.", "Therefore, D is B's daughter."]
                },
                {
                  question: "If E is F's brother and G is E's son, who is G to F?",
                  options: ["Nephew", "Brother", "Son", "Uncle"],
                  answer: "Nephew",
                  solution: ["E is F's brother.", "G is E's son.", "Therefore, G is F's nephew."]
                },
                {
                  question: "If H is I's sister and J is I's mother, how is J related to H?",
                  options: ["Aunt", "Mother", "Sister", "Grandmother"],
                  answer: "Mother",
                  solution: ["H is I's sister.", "J is I's mother.", "Therefore, J is H's mother."]
                },
                {
                  question: "If K is L's mother and M is L's brother, who is M to K?",
                  options: ["Son", "Brother", "Uncle", "Cousin"],
                  answer: "Son",
                  solution: ["K is L's mother.", "M is L's brother.", "Therefore, M is K's son."]
                },
                {
                  question: "If N is O's father and P is O's daughter, who is P to N?",
                  options: ["Granddaughter", "Daughter", "Sister", "Mother"],
                  answer: "Granddaughter",
                  solution: ["N is O's father.", "P is O's daughter.", "Therefore, P is N's granddaughter."]
                },
                {
                  question: "If Q is R's brother and S is R's son, who is S to Q?",
                  options: ["Nephew", "Brother", "Son", "Uncle"],
                  answer: "Nephew",
                  solution: ["Q is R's brother.", "S is R's son.", "Therefore, S is Q's nephew."]
                },
                {
                  question: "If T is U's mother and V is U's grandmother, who is V to T?",
                  options: ["Mother", "Daughter", "Mother-in-law", "Sister"],
                  answer: "Mother",
                  solution: ["T is U's mother.", "V is U's grandmother.", "Therefore, V is T's mother."]
                },
                {
                  question: "If W is X's father and Y is X's son, who is W to Y?",
                  options: ["Grandfather", "Father", "Uncle", "Brother"],
                  answer: "Grandfather",
                  solution: ["W is X's father.", "Y is X's son.", "Therefore, W is Y's grandfather."]
                },
                {
                  question: "If Z is A's sister and B is A's daughter, who is B to Z?",
                  options: ["Niece", "Sister", "Mother", "Cousin"],
                  answer: "Niece",
                  solution: ["Z is A's sister.", "B is A's daughter.", "Therefore, B is Z's niece."]
                },
                {
                  question: "If C is D's mother and E is D's sister, who is E to C?",
                  options: ["Daughter", "Sister", "Mother", "Granddaughter"],
                  answer: "Daughter",
                  solution: ["C is D's mother.", "E is D's sister.", "Therefore, E is C's daughter."]
                },
                {
                  question: "If F is G's brother and H is G's son, who is H to F?",
                  options: ["Nephew", "Brother", "Son", "Uncle"],
                  answer: "Nephew",
                  solution: ["F is G's brother.", "H is G's son.", "Therefore, H is F's nephew."]
                },
              
              
             
                

];

const Reasoning = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [result, setResult] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [showSolution, setShowSolution] = useState(false);

  const readQuestionAndOptions = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    const utterance = new SpeechSynthesisUtterance(currentQuestion.question);
    speechSynthesis.speak(utterance);

    currentQuestion.options.forEach((option, index) => {
      const optionUtterance = new SpeechSynthesisUtterance(`Option ${index + 1}: ${option}`);
      speechSynthesis.speak(optionUtterance);
    });
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSolve = () => {
    setShowSolution(true);
  };

  const handleSubmit = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    const isCorrect = currentQuestion.answer === selectedOption;
    if (isCorrect) {
      setResult('Correct!');
    } else {
      setResult(`Wrong! The correct answer is ${currentQuestion.answer}.`);
    }
    setShowResult(true);

    const utterance = new SpeechSynthesisUtterance(
      isCorrect ? 'Correct!' : `Wrong! The correct answer is ${currentQuestion.answer}.`
    );
    speechSynthesis.speak(utterance);
  };

  const handleNext = () => {
    const nextIndex = Math.floor(Math.random() * questionsData.length);
    setCurrentQuestionIndex(nextIndex);
    setSelectedOption('');
    setShowResult(false);
    setShowSolution(false);
  };

  const currentQuestion = questionsData[currentQuestionIndex];

  return (
    <div className="reasoning">
      <h1>Reasoning Questions</h1>
      <div className="question">
        <p>{currentQuestion.question}</p>
      </div>
      <div className="options">
        {currentQuestion.options.map((option, index) => (
          <label key={index}>
            <input
              type="radio"
              value={option}
              checked={selectedOption === option}
              onChange={handleOptionChange}
            />
            {option}
          </label>
        ))}
      </div>
      {showSolution && (
        <div className="solution">
          <h2>Solution:</h2>
          <ul>
            {currentQuestion.solution.map((step, index) => (
              <li key={index}>{step}</li>
            ))}
          </ul>
        </div>
      )}
      {showResult && (
        <div className="result">
          <p>{result}</p>
        </div>
      )}
      <div className="buttons">
        <button onClick={readQuestionAndOptions}>Read Question</button>
        <button onClick={handleSolve}>Solve</button>
        <button onClick={handleSubmit}>Submit</button>
        <button onClick={handleNext}>Next</button>
      </div>
    </div>
  );
};

export default Reasoning;
